import LocalOfferOutlined from '@mui/icons-material/LocalOfferOutlined';
import SpaOutlined from '@mui/icons-material/SpaOutlined';
import FaceRetouchingNaturalOutlined from '@mui/icons-material/FaceRetouchingNaturalOutlined';
import DocPageLayout from './DocPageLayout.js';
import './DocPage.css';

const heroImage = '/img/facial-care.webp';
const secondaryImage = '/img/counseling-session.jpg';

const CampaignFacialCare = () => (
    <DocPageLayout
        currentRoute="/campaign/facial-care"
        pageLabel="CAMPAIGN"
        pageTitle="小顔施術75分 キャンペーン"
        heroImage={heroImage}
        heroImageAlt="小顔施術の様子"
        heroHighlight="美容鍼と整体の組み合わせでフェイスラインを引き締める"
        heroDescription={[
            '全身調整から美容鍼、小顔整体までトータルケアで理想のフェイスラインへ導きます。',
            '肌質改善と表情筋のバランスを整え、内側から輝く美しさを引き出します。'
        ]}
    >
        <article className="doc-section">
            <h3 className="doc-section__title">
                <LocalOfferOutlined className="doc-section__icon" />キャンペーン概要
            </h3>
            <div className="doc-section__body">
                <p>
                    美容鍼と小顔整体をセットで体験いただける特別プランです。全身調整を行った後に、美容鍼と小顔整体でリフトアップと引き締め効果を高めます。
                </p>
                <div className="doc-highlight">
                    <p><strong>施術内容</strong> 鍼灸治療＋整体＋美容鍼 初回 100分 / 2回目以降 75分</p>
                    <p><strong>特別価格</strong> 19,800円 → 13,200円</p>
                    <p className="doc-note">※キャンペーンは予告なく終了する場合があります。</p>
                </div>
            </div>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <SpaOutlined className="doc-section__icon" />美容鍼の効果
            </h3>
            <div className="doc-section__body">
                <p>
                    鍼でツボを刺激すると「サイトカイン」が活性化し、細胞の再生を促進します。
                    肌のハリと弾力が高まり、シミやほうれい線、たるみの改善に繋がります。
                    新陳代謝が向上することで、くすみやニキビなどの肌トラブルにもアプローチします。
                </p>
                <div className="doc-section__media">
                    <img src={secondaryImage} alt="美容鍼のカウンセリング" loading="lazy" />
                </div>
            </div>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <FaceRetouchingNaturalOutlined className="doc-section__icon" />小顔整体で整える
            </h3>
            <div className="doc-section__body">
                <p>
                    顔の骨格と筋肉を本来の位置に導くことで、フェイスラインを整えながら動きやすい表情筋をつくります。
                    目が開きやすくなったり、口が動かしやすくなるなど機能面での変化も期待できます。
                </p>
            </div>
        </article>
    </DocPageLayout>
);

export default CampaignFacialCare;
